// @flow
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { DialogContent, withMobileDialog, DialogTitle } from '@material-ui/core';
import { sendBoostMessage } from '../../utils/ws-v1';
import { getSocketIfExist } from '../../utils/getSocket';

type Props = {
  updateBoosting: Function,
  fullScreen: Boolean,
  open: boolean,
  boostList: Array<string>,
};

type State = {
  boost: string,
};

const onDelete = word => {
  const ws = getSocketIfExist();
  sendBoostMessage(ws, {
    action: 'remove',
    word,
  });
};

const onCreate = word => {
  if (word.length) {
    const ws = getSocketIfExist();
    sendBoostMessage(ws, {
      action: 'add',
      word,
    });
  }
};

// eslint-disable-next-line
class BoostModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { boost: '' };
  }

  render() {
    const { updateBoosting, open, fullScreen, boostList } = this.props;
    const { boost } = this.state;

    return (
      <Dialog open={open} fullScreen={fullScreen}>
        <DialogContent>
          <DialogTitle variant="h5" style={{ alignSelf: 'center' }}>
            Boost
          </DialogTitle>
        </DialogContent>
        <div>
          <div className="row inputs">
            <div className="col-lg-7">
              <input
                type="text"
                name="band"
                placeholder="boost"
                onChange={e => this.setState({ boost: e.target.value })}
                value={boost}
                className="form-control"
                size="20"
              />
            </div>
            <div className="col-md-3">
              <button
                type="button"
                style={{ width: '100%' }}
                className="btn btn-success"
                onClick={() => {
                  onCreate(boost);
                }}
              >
                Add
              </button>
            </div>
          </div>
          <table className="table">
            <tbody>
              {boostList.map(data => {
                return (
                  <tr>
                    <td style={{ width: '30%' }}>{data}</td>
                    <td style={{ width: '10%' }}>
                      <button type="button" className="btn btn-danger" onClick={() => onDelete(data)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <DialogActions>
          <Button
            type="submit"
            onClick={() => {
              updateBoosting(false);
            }}
            color="secondary"
          >
            Quit
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(BoostModal);
